module.exports = __webpack_public_path__ + "img/patientphoto.700f8e0d.jpg";